import axios from 'axios';
import { registerService } from 'services';

const typeBlob = (fileType: string) => {
  switch (fileType) {
    case 'pdf':
      return { type: 'application/pdf' };
    case 'xlsx':
      return { type: 'application/octet-stream' };
    case 'csv':
      return { type: 'text/csv;charset=utf-8;' };
    default:
      return { type: 'application/octet-stream' };
  }
};

export const exportFile = async (dataExport: any, fileExt: string, fileTemplate: string, nameSave: string) => {
  try {
    const { data: resultToken } = await registerService.getTokenDocurain({
      conditions: [
        {
          id: 'key',
          search_value: ['DOCURAIN_TOKEN'],
        },
      ],
    });

    if (resultToken.items[0]) {
      const { data } = await axios({
        url: `https://api.docurain.jp/api/${fileExt}/${fileTemplate}`,
        method: 'POST',
        data: dataExport,
        responseType: 'blob',
        headers: {
          Authorization: `token ${resultToken.items[0].value}`,
          'Content-Type': 'application/json',
        },
      });
      const file = new Blob([data], typeBlob(fileExt));
      saveAs(file, `${nameSave}.${fileExt}`);
      return file;
    }
  } catch (error) {
    return 'error';
  }
};
